import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import SocialProof from "@/components/SocialProof";
import ArchitectsSection from "@/components/ArchitectsSection";
import GallerySection from "@/components/GallerySection";
import ContactSection from "@/components/ContactSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEO from "@/components/SEO";

const Index = () => {
  const keywords = [
    "אור בגג", "גגן מומלץ חיפה", "מומחה גגות חיפה", "קבלן גגות חיפה",
    "גגות ופחחות חיפה", "תיקון גגות בחיפה והקריות",
    "תיקון גג רעפים חיפה", "תיקון גגות רעפים בקריות", "גגן רעפים חיפה",
    "בניית גג רעפים חיפה", "החלפת רעפים חיפה", "תיקון נזילות גג רעפים",
    "איטום גגות חיפה", "איטום גג שטוח חיפה", "איטום גגות קריות",
    "זיפות גגות חיפה", "מחיר איטום גג חיפה",
    "פחחות גגות חיפה", "התקנת מרזבים חיפה", "תיקון מרזבים קריות",
    "ניקוז גגות חיפה", "ארגזי רוח גגות",
  ];

  const serviceOffers = [
    "תיקון גג רעפים", "החלפת רעפים", "בניית גג רעפים",
    "איטום גגות שטוחים וזיפות", "איתור ותיקון נזילות",
    "פחחות גגות", "התקנת מרזבים", "תיקון מרזבים",
    "ניקוז גגות", "ארגזי רוח", "אוורור גגות",
  ];

  const localBusinessJsonLd = {
    "@context": "https://schema.org",
    "@type": "RoofingContractor",
    name: "אור בגג",
    description:
      "גגן מומלץ בחיפה והקריות – תיקון גג רעפים, איטום גגות, פחחות ומרזבים עם 13 שנות ניסיון ואחריות מלאה.",
    url: "https://orbagag.com",
    telephone: "+972-54-572-5681",
    email: "or.perias@gmail.com",
    image: "https://orbagag.com/og-image.jpg",
    priceRange: "₪₪",
    keywords: keywords.join(", "),
    areaServed: ["חיפה", "קריות", "נשר", "עכו", "יקנעם", "טירת כרמל", "עתלית"],
    address: {
      "@type": "PostalAddress",
      addressCountry: "IL",
      addressLocality: "חיפה והסביבה",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "שירותי גגות ופחחות",
      itemListElement: serviceOffers.map((name) => ({
        "@type": "Offer",
        itemOffered: { "@type": "Service", name, areaServed: "חיפה והקריות" },
      })),
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
        opens: "07:00",
        closes: "18:00",
      },
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: "Friday",
        opens: "07:00",
        closes: "13:00",
      },
    ],
  };

  return (
    <div className="min-h-screen">
      <SEO
        path="/"
        title="אור בגג – גגן מומלץ בחיפה והקריות | תיקון גג רעפים, איטום ופחחות"
        description="גגן מומחה בחיפה והקריות עם 13 שנות ניסיון: תיקון גג רעפים, החלפת רעפים, איטום גגות שטוחים, פחחות ומרזבים. אחריות מלאה והצעת מחיר חינם."
        jsonLd={localBusinessJsonLd}
      />
      <Header />
      <main id="main">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <SocialProof />
        <ArchitectsSection />
        <GallerySection />
        <FAQSection />
        <ContactSection />
        {/* SEO content – hidden visually, available to search engines and screen readers */}
        <section aria-label="תחומי התמחות ואזורי שירות" className="sr-only">
          <h2>גגן מומלץ בחיפה והקריות – אור בגג</h2>
          <p>
            אור בגג הוא קבלן ומומחה גגות בחיפה והקריות, עם מעל 13 שנות ניסיון בתחום הגגות והפחחות.
            אנו מתמחים בתיקון גג רעפים, החלפת רעפים, בניית גג רעפים חדש ותיקון נזילות בגגות רעפים.
            בנוסף, אנו מבצעים איטום גגות חיפה, איטום גג שטוח, איטום גגות בקריות וזיפות גגות במחירים הוגנים.
            בתחום הפחחות אנו מספקים פחחות גגות, התקנת מרזבים, תיקון מרזבים בקריות, ניקוז גגות וארגזי רוח.
            השירות פעיל בחיפה, קריות, נשר, עכו, יקנעם, טירת כרמל ועתלית – לפרויקטים פרטיים, עסקיים ולאדריכלים.
          </p>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
